import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";
import { Review } from "../models/review";

@Injectable()
export class ReviewsService {
  constructor(private apollo: Apollo) {}

  getAllReviewsByOrganizationId(id: string, obj?: any) {
    // Initialize variables object
    let variables: any = {
      organizationId: id,
    };
    console.log("obj", obj);
    // Add pagination and search parameters if available
    if (obj) {
      variables = {
        ...variables, // Keep organizationId
        first: obj.paginationData.pageSize || 10, // Default to 10 if pageSize is not provided
        after: obj.paginationData.after
          ? obj.paginationData.after.endCursor
          : null, // Use cursor-based pagination
        searchParam: obj.searchParam || "", // Empty string if no search parameter
      };
    }
    console.log("variables", variables);

    return this.apollo.watchQuery({
      query: gql`
        query GetReviews(
          $organizationId: String!
          $first: Int
          $after: String
          $searchParam: String
        ) {
          reviews(
            organizationId: $organizationId
            first: $first
            after: $after
            searchParam: $searchParam
          ) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                clientName
                clientLocation
                tripType
                status
              }
              cursor
            }
            totalCount
          }
        }
      `,
      variables,
      errorPolicy: "all",
    }).valueChanges;
  }

  findOneReview(id: string) {
    return this.apollo.watchQuery({
      query: gql`
          {
            review(id: "${id}") {
              id
              clientName
              clientLocation
              tripType
              status
              review
              source
              topReview
              organization {
                id
                name
              }
              photos {
                id
                url
                originalUrl
                path
                mimetype
                credit
                caption
                editor
              }
              video {
                id
                url
                path
                mimetype
              }
            }
          }
        `,
    }).valueChanges;
  }

  createReview(review: Review) {
    return this.apollo.mutate({
      mutation: gql`
        mutation createReview(
          $organizationId: String!
          $clientLocation: String
          $tripType: String
          $clientName: String!
          $status: String
          $review: String!
          $source: String
          $topReview: Boolean!
        ) {
          createReview(
            review: {
              organizationId: $organizationId
              clientLocation: $clientLocation
              tripType: $tripType
              status: $status
              review: $review
              source: $source
              clientName: $clientName
              topReview: $topReview
            }
          ) {
            id
          }
        }
      `,
      variables: {
        organizationId: review.organization.id,
        clientName: review.clientName,
        clientLocation: review.clientLocation,
        tripType: review.tripType,
        status: review.status,
        review: review.review,
        source: review.source,
        topReview: !!review.topReview,
      },
    });
  }

  updateReview(review: Review) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateReview(
          $id: String!
          $clientLocation: String
          $tripType: String
          $status: String
          $review: String!
          $source: String
          $clientName: String!
          $topReview: Boolean!
        ) {
          updateReview(
            id: $id
            review: {
              clientLocation: $clientLocation
              tripType: $tripType
              status: $status
              review: $review
              source: $source
              clientName: $clientName
              topReview: $topReview
            }
          ) {
            success
          }
        }
      `,
      variables: {
        id: review.id,
        clientName: review.clientName,
        clientLocation: review.clientLocation,
        tripType: review.tripType,
        status: review.status,
        review: review.review,
        source: review.source,
        topReview: !!review.topReview,
      },
    });
  }

  deleteReview(reviewId: string) {
    return this.apollo.mutate({
      mutation: gql`
          mutation removeReview {
            removeReview(id: "${reviewId}") {
              success
            }
          }
        `,
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/reviews.service.ts